'use strict';

/* globals Modernizr */

const _ = require('lodash');

const ResetPasswordFormController = function ($scope, $stateParams, sbAuth, IntercomService) {

  const vm = this;
  vm.buttonText = 'Log in';
  vm.currentView = '';
  vm.error = '';
  vm.inputs = ['password', 'confirmPassword'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.menuActive = false;
  vm.showDialog = false;
  vm.text = 'This link has expired. Please reset your password again.';
  vm.data = {
    confirmPassword: '',
    origin: $stateParams.origin,
    password: '',
    resetToken: $stateParams.reset || $stateParams.invite
  };

  vm.loadingSendEmail = false;

  vm.login = _.debounce(() => {

    vm.buttonText = 'Loading...';
    vm.loadingSendEmail = true;
    if (vm.data.origin === 'cmdr') {
      vm.currentView = 'confirmation';
    }
    else {
      vm.data.origin = 'core'; // Needed for sbAuth to broadcast auth:success
    }

    const onError = (res) => {

      vm.buttonText = 'Log in';
      vm.loadingSendEmail = false;
      vm.error = res.error;
    };

    sbAuth.resetPassword(vm.data, null, onError);
  }, 0);

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = ResetPasswordFormController;



// WEBPACK FOOTER //
// ./src/app/login/resetPasswordForm/ResetPasswordFormController.js